
export default {
  /**
   * 获取登录token
   */
  getToken(){
    return localStorage.getItem('vmp-token');
  },

  /**
   * 更新token
   */
  setToken(token) {
    localStorage.setItem('vmp-token', token);
  },

  /**
   * 存储用户信息
   */
  setUser(user){
    localStorage.setItem('vmp-user', JSON.stringify(user));
  },

  /**
   * 获取用户
   */
  getUser(){
    return JSON.parse(localStorage.getItem('vmp-user'));
  },

  /**
   * 清理用户信息
   */
  clearUserInfo() {
    console.log('clearUserInfo')
    localStorage.removeItem('vmp-user');
    localStorage.removeItem('vmp-token');
  },

  clearAllStorage() {
    window.sessionStorage.clear();
    window.localStorage.clear();
  },
}



// WEBPACK FOOTER //
// ./src/components/service/UserService.js